import type { FC } from 'react';

import Button from 'components/atoms/Button';
import { ButtonModes } from 'constants/ButtonModes';

const MAIN_CONTENT_ID = 'main-content';

export const SkipToMainContentButton: FC = () => (
  <Button
    mode={ButtonModes.secondary}
    className="absolute left-[-9999px] m-4 z-10 active:left-0 focus:left-0"
    href={`#${MAIN_CONTENT_ID}`}
  >
    Skip to Main Content
  </Button>
);

export const SkipToMainContentTarget: FC = () => (
  <div className="w-[1px] h-[1px] overflow-hidden float-right">
    <p id={MAIN_CONTENT_ID} tabIndex={-1}>
      -
    </p>
  </div>
);
